<template>
  <component
    :is="scaleFactTemplate"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.fact')"
    :data="scope.row.scale"
    @change="saveElementPropChange(scope.row, 'scale', {fact:$event})"
  ></component>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-fact-table-column',
  mixins: [ElementPropTableColumn],
  components: {ClickToEdit},

  props: {},
  data() {
    return {

    }
  },
  computed: {
    scaleFactTemplate() {
      if( !this.scope.row.scale_type ){
        return null;
      }
      return this.$companyConfiguration.scales.getScaleTemplate(this.scope.row.scale_type, 'cardFactView');
    },
  },
  methods: {}
}

</script>

<style>

</style>
